const SESSION_ID_KEY = 'pih.auditSessionId';
const SESSION_STARTED_KEY = 'pih.auditSessionStartedAt';
const SESSION_LAST_ACTIVITY_KEY = 'pih.auditSessionLastActivityAt';

export const AUDIT_SESSION_TTL_MS = 60 * 60 * 1000;

function generateSessionId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `S-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}

function readStorage(key) {
  try {
    return localStorage.getItem(key) || sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

function writeStorage(key, value) {
  try {
    localStorage.setItem(key, value);
    sessionStorage.setItem(key, value);
  } catch {
    /* ignore */
  }
}

function removeStorage(key) {
  try {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}

function parseTime(iso) {
  if (!iso) return null;
  const t = Date.parse(iso);
  return Number.isFinite(t) ? t : null;
}

function isSessionExpired() {
  const last = parseTime(readStorage(SESSION_LAST_ACTIVITY_KEY));
  if (last == null) return true;
  return Date.now() - last > AUDIT_SESSION_TTL_MS;
}

function touchSessionActivity() {
  writeStorage(SESSION_LAST_ACTIVITY_KEY, new Date().toISOString());
}

export function getAuditSessionId() {
  return readStorage(SESSION_ID_KEY);
}

export function startNewAuditSession() {
  const sessionId = generateSessionId();
  const now = new Date().toISOString();
  writeStorage(SESSION_ID_KEY, sessionId);
  writeStorage(SESSION_STARTED_KEY, now);
  writeStorage(SESSION_LAST_ACTIVITY_KEY, now);
  return sessionId;
}

export function ensureAuditSession() {
  const existing = getAuditSessionId();
  if (existing && !isSessionExpired()) {
    touchSessionActivity();
    return existing;
  }
  return startNewAuditSession();
}

export function clearAuditSession() {
  removeStorage(SESSION_ID_KEY);
  removeStorage(SESSION_STARTED_KEY);
  removeStorage(SESSION_LAST_ACTIVITY_KEY);
}
